import React, { useState } from 'react';
import { ReportGenerationModal } from '../utils/summary_report/ReportGenerationModal';
import { ReportFilters } from '../types/types';

interface GenerateReportButtonProps {
  onGenerate: (filters: ReportFilters) => void | Promise<void>;
  availableYears?: number[];
}

export function GenerateReportButton({ onGenerate, availableYears }: GenerateReportButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className="text-xs font-semibold text-[#EA580C] dark:text-[#FB923C] hover:text-[#C2410C] dark:hover:text-[#F97316] transition-colors"
      >
        Generate report
      </button>
      {isModalOpen && (
        <ReportGenerationModal
          availableYears={availableYears}
          onClose={() => setIsModalOpen(false)}
          onGenerate={async (filters: ReportFilters) => {
            await onGenerate(filters);
            setIsModalOpen(false);
          }}
        />
      )}
    </>
  );
}
